import { render, staticRenderFns } from "./coverDetail.vue?vue&type=template&id=c3d01aec&scoped=true"
import script from "./coverDetail.vue?vue&type=script&lang=js"
export * from "./coverDetail.vue?vue&type=script&lang=js"
import style0 from "./coverDetail.vue?vue&type=style&index=0&id=c3d01aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d01aec",
  null
  
)

export default component.exports